import React, { Component } from 'react';
import successLogo from './../../../../../statics/img/tabby/success.svg';
import failLogo from './../../../../../statics/img/esaypaisa/fail.svg';
import pendingLogo from './../../../../../statics/img/esaypaisa/pending.svg';
import './Tabby.css';

class TabbyStatus extends Component {
    
    componentDidMount (){
        setTimeout(()=>{
            if(this.props.status_message == "Transaction abandoned."){
                window.history.back();
            }else{
                window.top.location.href = this.props.redirection_url;
            }
            
        },3000)
    }

    renderSuccess = () => (
        <div>
            <img src={successLogo} />
            <h4>Transaction Successful.</h4>
            <p>{this.props.status_message}</p>
        </div>
    )

    renderFail = () => (
        <div>
            <img src={failLogo} />
            <h4>Payment failed</h4>
            <p>{this.props.status_message}</p>
        </div>
    )

    renderPending = () => (
        <div>
            <img src={pendingLogo} />
            <h4>Payment pending</h4>
            <p>{this.props.status_message}</p>
        </div>
    )

    render() {
        return (
            <div className="tabby_content tabby_status">
                {this.props.tabby_status == "success" && this.renderSuccess()}
                {this.props.tabby_status == "fail" && this.renderFail()}
                {this.props.tabby_status == "pending" && this.renderPending()}
            </div>
        )
    }
}
export default TabbyStatus;